import sort from './sort'

const reports = {
  regioes: [
    {
      title: 'Clientes ativos',
      route: 'relatorios-regiao-cliente-ativo-show',
      disabled: false,
      period: false
    },
    {
      title: 'Clientes inativos',
      route: 'relatorios-regiao-cliente-inativo-show',
      disabled: false,
      period: false
    },
    {
      title: 'Geolocalização',
      route: 'relatorios-regiao-geolocalizacao-show',
      disabled: false,
      period: false
    },
    {
      title: 'Cidades',
      route: 'relatorios-regiao-cidade-show',
      disabled: false,
      period: false
    },
    {
      title: 'Valor pago no leite',
      route: 'relatorios-regiao-valor-leite-show',
      disabled: false,
      period: true
    },
    {
      title: 'Volume de produção',
      route: 'relatorios-regiao-producao-show',
      disabled: false,
      period: true
    },
    {
      title: 'Total de vacas em lactação',
      route: 'relatorios-regiao-lactacao-show',
      disabled: false,
      period: true
    }
  ],
  municipios: [
    {
      title: 'Clientes ativos',
      route: 'relatorios-cidade-cliente-ativo-show',
      disabled: false,
      period: false
    },
    {
      title: 'Clientes inativos',
      route: 'relatorios-cidade-cliente-inativo-show',
      disabled: false,
      period: false
    },
    {
      title: 'Geolocalização',
      route: 'relatorios-cidade-geolocalizacao-show',
      disabled: false,
      period: false
    },
    {
      title: 'Total de vacas em lactação',
      route: 'relatorios-cidade-lactacao-show',
      disabled: false,
      period: true
    }
  ],
  tecnico: [
    {
      title: 'Clientes atendidos (todos)',
      route: 'relatorios-tecnico-cliente-atendido-show',
      disabled: false,
      period: true
    },
    {
      title: 'Clientes atendidos (balancete requerido)',
      route: 'relatorios-tecnico-cliente-atendido-balancete-requerido-show',
      disabled: false,
      period: true
    },
    {
      title: 'Clientes atendidos (balancete não requerido)',
      route: 'relatorios-tecnico-cliente-atendido-balancete-nao-requerido-show',
      disabled: false,
      period: true
    }
  ],
  industria: [
    {
      title: 'Contratos em andamento',
      route: 'relatorios-industria-contrato-ativo-show',
      disabled: false,
      period: false
    },
    {
      title: 'Contratos concluídos',
      route: 'relatorios-industria-contrato-inativo-show',
      disabled: false,
      period: false
    },
    {
      title: 'Proteína',
      route: 'relatorios-industria-proteina-show',
      disabled: false,
      period: true
    },
    {
      title: 'Gordura',
      route: 'relatorios-industria-gordura-show',
      disabled: false,
      period: true
    },
    {
      title: 'Lactose',
      route: 'relatorios-industria-lactose-show',
      disabled: false,
      period: true
    },
    {
      title: 'Sólidos',
      route: 'relatorios-industria-solido-show',
      disabled: false,
      period: true
    },
    {
      title: 'CCS',
      route: 'relatorios-industria-ccs-show',
      disabled: false,
      period: true
    },
    {
      title: 'CCS/CPP',
      route: 'relatorios-industria-ccs-cpp-show',
      disabled: false,
      period: true
    },
    {
      title: 'CPP',
      route: 'relatorios-industria-cpp-show',
      disabled: false,
      period: true
    },
    {
      title: 'ESD',
      route: 'relatorios-industria-esd-show',
      disabled: false,
      period: true
    },
    {
      title: 'Volume',
      route: 'relatorios-industria-volume-show',
      disabled: true,
      period: true
    }
  ],
  contrato: [
    {
      title: 'Etapas do projeto',
      route: 'relatorios-contrato-etapas-show',
      disabled: false,
      forceIcon: 'bubble_chart',
      period: true
    } // alterar a migration e add volume
  ],
  producao: [
    {
      title: 'Proteína',
      route: 'relatorios-producao-proteina-show',
      disabled: false,
      period: true
    },
    {
      title: 'Gordura',
      route: 'relatorios-producao-gordura-show',
      disabled: false,
      period: true
    },
    {
      title: 'Lactose',
      route: 'relatorios-producao-lactose-show',
      disabled: false,
      period: true
    },
    {
      title: 'Sólidos',
      route: 'relatorios-producao-solido-show',
      disabled: false,
      period: true
    },
    {
      title: 'CCS',
      route: 'relatorios-producao-ccs-show',
      disabled: false,
      period: true
    },
    {
      title: 'CPP',
      route: 'relatorios-producao-cpp-show',
      disabled: false,
      period: true
    },
    {
      title: 'ESD',
      route: 'relatorios-producao-esd-show',
      disabled: false,
      period: true
    },
    {
      title: 'Vacas em lactação',
      route: 'relatorios-producao-lactacao-show',
      disabled: false,
      period: true
    },
    {
      title: 'Vacas secas',
      route: 'relatorios-producao-seca-show',
      disabled: true,
      period: true
    },
    {
      title: 'Produção média do leite',
      route: 'relatorios-producao-media-leite-show',
      disabled: false,
      period: true
    },
    {
      title: 'Produção total estimada no mês',
      route: 'relatorios-producao-total-estimada-mes-show',
      disabled: false,
      period: true
    },
    {
      title: 'Valor pago no leite',
      route: 'relatorios-producao-valor-pago-leite-show',
      disabled: false,
      period: true
    },
    {
      title: 'Custo da alimentação/litro',
      route: 'relatorios-producao-custo-alimentacao-litro-show',
      disabled: false,
      period: true
    },
    {
      title: 'Custo de alimentação concentrada das vacas em lactação',
      route: 'relatorios-custo-alimentacao-concentrada-lactacao-show',
      disabled: false,
      period: true
    },
    {
      title: 'Custo de alimentação volumosa das vacas em lactação',
      route: 'relatorios-custo-alimentacao-volumosa-lactacao-show',
      disabled: false,
      period: true
    },
    {
      title: 'Receita estimada com o leite',
      route: 'relatorios-producao-receita-estimada-leite-show',
      disabled: false,
      period: true
    },
    {
      title: 'Despesas estimada com alimentação',
      route: 'relatorios-producao-despesa-estimada-alimentacao-show',
      disabled: false,
      period: true
    },
    {
      title: 'Sobra estimada',
      route: 'relatorios-producao-sobra-estimada-show',
      disabled: false,
      period: true
    }
  ]
}

const main = [
  {
    title: 'Produção',
    subtitle: 'Receita estimada, lactose, volume, número de vacas secas...',
    route: 'relatorios-producao-index'
  },
  {
    title: 'Regiões',
    subtitle:
      'Clientes ativos/inativos, volume de produção, vacas em lactação...',
    route: 'relatorios-regiao-index'
  },
  {
    title: 'Cidades',
    subtitle: 'Clientes ativos/inativos e total de vacas em lactação.',
    route: 'relatorios-cidade-index'
  },
  {
    title: 'Técnicos',
    subtitle: 'Produtores atendidos.',
    route: 'relatorios-tecnico-index'
  },
  {
    title: 'Indústrias',
    subtitle: 'Clientes ativos/inativos e total de vacas em lactação.',
    route: 'relatorios-industria-index'
  },
  {
    title: 'Contratos cliente/industria',
    subtitle: 'Relatório de etapas do projeto.',
    route: 'relatorios-contrato-index'
  }
]

export default array =>
  !array ? sort('title', main) : sort('title', reports[String(array)])
